import { Component, OnInit, Input, Output, ViewChildren, QueryList, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Pagination } from 'src/app/models/pagination.model';

interface SearchResult {
  items: any[];
  total: number;
}

interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortColumn: string;
  sortDirection: string;
}

@Component({
  selector: 'ct-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit {

  headers: {column, direction}[];

  @Input() items$: Observable<Pagination<any>>;
  @Output() reload = new EventEmitter<{ page: number }>();

  state: State = {
    page: 1,
    pageSize: 2,
    searchTerm: '',
    sortColumn: '',
    sortDirection: ''
  };

  currentPage: number;

  constructor() { }

  ngOnInit(): void {
    this.items$.subscribe(items => {
      this.currentPage = items?.currentPage;
    });
  }

  onSort({column, direction}) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.column !== column) {
        header.direction = '';
      }
    });

    this.state.sortColumn = column;
    this.state.sortDirection = direction;
  }

  //

  compare(v1: string, v2: string) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  sort(items: Pagination<any>, column: string, direction: string): any[] {
    if (direction === '' || column === '') {
      return items.data;
    } else {
      return [...items.data].sort((a, b) => {
        const res = this.compare(`${a[column]}`, `${b[column]}`);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  matches<T>(item: T, term: string) {
    let match: boolean;
    for (const prop in item) {
      if (prop) {
        match = match || prop.toLowerCase().includes(term.toLowerCase());
      }
    }
    return match;
  }

  search(): Observable<SearchResult> {
    const {sortColumn, sortDirection, pageSize, page, searchTerm} = this.state;

    return this.items$.pipe(switchMap(items => {
      // 1. sort
      let filteredItems: any[] = this.sort(items, sortColumn, sortDirection);

      // 2. filter
      filteredItems = filteredItems.filter(item => this.matches<any>(item, searchTerm));
      const total = filteredItems.length;

      // 3. paginate
      filteredItems = filteredItems.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
      return of({ items: filteredItems, total });
    }));
  }

}
